import { LegalLayout, LegalSection } from "../components/Legal";

const SECTIONS = [
  {
    title: "Acceptance of These Terms",
    content: (
      <p>
        By using this website, requesting an estimate, or booking a service with Cindyrella
        Cleaning LLC (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;), you agree to
        these Terms of Service. If you enter into a separate written service agreement or
        contract with us, the terms of that agreement will govern in case of any conflict.
      </p>
    ),
  },
  {
    title: "Our Services & Service Area",
    content: (
      <p>
        Cindyrella Cleaning LLC provides professional cleaning services for residential homes,
        vacation rentals, restaurants, offices, and government and
        municipal properties. We serve Naples, FL and Collier County, including North Naples,
        East Naples, Golden Gate, Marco Island, and Bonita Springs. All services are subject to a
        personalized quote and mutual scheduling agreement. For commercial and government
        clients, we work under written service agreements with defined scopes of work, schedules,
        and performance standards.
      </p>
    ),
  },
  {
    title: "Quotes & Estimates",
    content: (
      <p>
        Quotes and online estimates are free and non-binding. Final pricing is confirmed after we
        review the details of your space. Prices may be adjusted, with your prior approval, if
        the condition or scope of the property differs significantly from what was described. All
        quotes are transparent — no hidden fees.
      </p>
    ),
  },
  {
    title: "Scheduling, Cancellations & Access",
    content: (
      <p>
        We ask for at least 24 hours&rsquo; notice to reschedule or cancel a service. Repeated
        same-day cancellations may incur a fee. If we ever need to adjust a scheduled visit, we
        will notify you promptly. The client is responsible for providing safe and reasonable
        access to the property at the scheduled time (keys, codes, or on-site access as agreed).
      </p>
    ),
  },
  {
    title: "Payment Terms",
    content: (
      <p>
        Payment terms are confirmed with your quote or service agreement. Residential services
        are typically payable upon completion. Commercial and government accounts are invoiced
        according to the agreed contract terms (typically net 30 unless otherwise specified).
        Late payments on commercial accounts may be subject to reasonable late charges as stated
        in the applicable agreement.
      </p>
    ),
  },
  {
    title: "Satisfaction Guarantee",
    content: (
      <p>
        Our standard is simple: leave every space better than we found it, every single time. If
        you are not satisfied with any part of a completed service, notify us within 24 hours and
        we will return to re-clean the affected areas at no additional cost.
      </p>
    ),
  },
  {
    title: "Insurance & Liability",
    content: (
      <p>
        Cindyrella Cleaning LLC is licensed and fully insured, including general liability
        coverage. Any damage claim must be reported within 24 hours of the completed service so
        we can investigate and resolve it fairly. Certificates of insurance are available to
        commercial and government clients upon request. We are not responsible for pre-existing
        damage, inherently fragile items not disclosed to us, or conditions outside the agreed
        scope of work.
      </p>
    ),
  },
  {
    title: "Our Team & Conduct",
    content: (
      <p>
        Our staff are trained, supervised, and held to professional standards of conduct,
        appearance, and confidentiality. We respect your property, your privacy, and any
        site-specific rules, including security and safety protocols required at commercial and
        government facilities.
      </p>
    ),
  },
  {
    title: "Website Use & Communications",
    content: (
      <p>
        The content of this website is for informational purposes. By submitting a form,
        requesting an estimate, or using the chat assistant, you consent to being contacted by
        our team using the information you provided. All website content, including text, images,
        and branding, is the property of Cindyrella Cleaning LLC and may not be reproduced
        without permission.
      </p>
    ),
  },
  {
    title: "Limitation of Liability",
    content: (
      <p>
        To the maximum extent permitted by law, our total liability for any claim arising from a
        service is limited to the amount paid for that service, except where a written service
        agreement or applicable law provides otherwise. Nothing in these terms limits liability
        that cannot be limited under Florida law.
      </p>
    ),
  },
  {
    title: "Governing Law",
    content: (
      <p>
        These Terms are governed by the laws of the State of Florida. Any dispute will be
        resolved in the courts of Collier County, Florida, unless a written agreement between the
        parties provides otherwise. If any provision of these Terms is found unenforceable, the
        remaining provisions remain in full effect.
      </p>
    ),
  },
  {
    title: "Changes to These Terms",
    content: (
      <p>
        We may update these Terms from time to time. The &ldquo;Last updated&rdquo; date at the
        top reflects the most recent version.
      </p>
    ),
  },
];

export default function TermsPage() {
  return (
    <LegalLayout badge="Legal" title="Terms of Service" testid="terms-page">
      {SECTIONS.map(({ title, content }) => (
        <LegalSection key={title} title={title}>
          {content}
        </LegalSection>
      ))}
    </LegalLayout>
  );
}
